import { ref } from "vue";
import { showAlert } from "@sazka/design-system/src/modal-alert/mount-alert";
import { useNgSession } from "@sazka/ng/ng-session";

const webViewDebugModeOn = ref(false);

export default function useWebviewDebugMode() {
    const initWebviewDebugMode = (): void => {
        try {
            if (environment.env == "Production") return;
            // Create debug button
            const debugBtn = document.createElement("button");
            debugBtn.className = "webview-debug";
            debugBtn.attributes["type"] = "button";
            debugBtn.onclick = () => {
                webViewDebugModeOn.value = !webViewDebugModeOn.value;
                document.querySelector(".webview-debug__mode")?.classList.toggle("webview-debug__mode--active");
                if (webViewDebugModeOn.value) {
                    const { session } = useNgSession();

                    showAlert({
                        title: "WebView Debug Mode",
                        subText: `Aplikace: ${environment.appName}<br/>
                        URL: ${window.location.href}<br/>
                        PlayerId z BE: ${window.player?.id || "---"}<br/>
                        PlayerId od NG: ${session.value?.PlayerID || "---"}<br/>
                        SessionToken z BE: ${window.player?.sessionToken || "---"}<br/>
                        SessionToken od NG: ${session.value?.SessionToken || "---"}<br/>`,
                    });
                }
            };

            debugBtn.insertAdjacentHTML(
                "beforeend",
                '<span>WebView Debug</span> <span class="webview-debug__mode">Active</span>'
            );
            document.querySelector("body").appendChild(debugBtn);
        } catch (e) {
            console.error(`WebView Debug Mode Initialiazation Failed: ${e}`);
        }
    };

    const showEventAlert = (interfaceName: string, methodName: string, argument: string): void => {
        try {
            if (!webViewDebugModeOn.value) return;

            const eventMessage =
                argument !== null && argument !== undefined
                    ? `Interface ${interfaceName}; method ${methodName}('${argument}')`
                    : `Interface ${interfaceName}; method ${methodName}()`;
            confirm(eventMessage);
        } catch (e) {
            console.error(`Show Alert For WebView Debug Mode Failed: ${e}`);
        }
    };

    return {
        showEventAlert,
        initWebviewDebugMode,
        webViewDebugModeOn,
    };
}
